//
//
//
//
//
//
//
//
//
//
//
//
//
//
// 引入 codemirror 组件
import { codemirror } from 'vue-codemirror'; // 引入核心样式

import 'codemirror/lib/codemirror.css'; // 引入 SQL 语法高亮模式

import 'codemirror/mode/sql/sql'; // 引入主题（可以根据需要选择）

import 'codemirror/theme/monokai.css'; // 深色主题
// import 'codemirror/theme/eclipse.css'   // 浅色主题
// import 'codemirror/theme/material.css'  // Material 主题
// 引入辅助功能（可选）

import 'codemirror/addon/edit/closebrackets'; // 自动闭合括号

import 'codemirror/addon/edit/matchbrackets'; // 括号匹配

import 'codemirror/addon/selection/active-line'; // 高亮当前行

import 'codemirror/addon/fold/foldcode'; // 代码折叠

import 'codemirror/addon/fold/foldgutter'; // 折叠区域标记

import 'codemirror/addon/fold/indent-fold'; // 缩进折叠

import 'codemirror/addon/display/autorefresh'; // 自动刷新

export default {
  name: 'SqlEditor',
  components: {
    codemirror: codemirror
  },
  props: {
    // 输入值（支持 v-model）
    value: {
      type: String,
      default: ''
    },
    // 是否禁用
    disabled: {
      type: Boolean,
      default: false
    },
    // 是否只读
    readonly: {
      type: Boolean,
      default: false
    },
    // 编辑器高度
    height: {
      type: String,
      default: '300px'
    },
    // 占位符提示
    placeholder: {
      type: String,
      default: '请输入 SQL 语句...'
    }
  },
  data: function data() {
    return {
      currentValue: this.value,
      editorOptions: {
        // 基本配置
        mode: 'text/x-sql',
        // SQL 语法模式
        theme: 'monokai',
        // 主题样式
        lineNumbers: true,
        // 显示行号
        lineWrapping: true,
        // 自动换行
        tabSize: 2,
        // Tab 缩进空格数
        indentWithTabs: true,
        // 使用 Tab 缩进
        // 编辑功能
        autoCloseBrackets: true,
        // 自动闭合括号
        matchBrackets: true,
        // 括号匹配高亮
        styleActiveLine: true,
        // 高亮当前行
        autoIndent: true,
        // 自动缩进
        // 代码折叠
        foldGutter: true,
        // 显示折叠标记
        gutters: ['CodeMirror-linenumbers', 'CodeMirror-foldgutter'],
        // 其他配置
        readOnly: this.readonly,
        // 只读模式
        disabled: this.disabled,
        // 禁用模式
        placeholder: this.placeholder,
        // 占位符
        scrollbarStyle: 'native',
        // 滚动条样式
        viewportMargin: Infinity // 自动调整高度

      }
    };
  },
  watch: {
    // 监听外部传入的 value 变化
    value: function value(newVal) {
      if (newVal !== this.currentValue) {
        this.currentValue = newVal;
      }
    },
    // 监听 readonly 变化
    readonly: function readonly(newVal) {
      this.editorOptions.readOnly = newVal;
    },
    // 监听 disabled 变化
    disabled: function disabled(newVal) {
      this.editorOptions.disabled = newVal;
    }
  },
  methods: {
    // 内容变化时触发
    handleInput: function handleInput(newValue) {
      this.$emit('input', newValue);
      this.$emit('change', newValue);
    },
    // 编辑器初始化完成
    handleReady: function handleReady(editor) {
      this.$emit('ready', editor);
    },
    // 获取焦点
    handleFocus: function handleFocus() {
      this.$emit('focus');
    },
    // 失去焦点
    handleBlur: function handleBlur() {
      this.$emit('blur', this.currentValue);
    },
    // 获取编辑器实例（供父组件调用）
    getEditor: function getEditor() {
      return this.$refs.cmEditor.editor;
    },
    // 获取当前值（供父组件调用）
    getValue: function getValue() {
      return this.currentValue;
    },
    // 设置值（供父组件调用）
    setValue: function setValue(value) {
      this.currentValue = value;
      this.$emit('input', value);
    },
    // 刷新编辑器（解决显示问题）
    refresh: function refresh() {
      if (this.$refs.cmEditor && this.$refs.cmEditor.editor) {
        this.$refs.cmEditor.editor.refresh();
      }
    }
  },
  mounted: function mounted() {
    var _this = this;

    // 确保编辑器正确渲染
    this.$nextTick(function () {
      _this.refresh();
    });
  }
};